import React, { useContext } from 'react';
import './Blog.css';
import { Link } from 'react-router-dom';
import { PostStore } from '../../store/PostStore';

import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";

const Blog = () => {

    const { posts } = useContext(PostStore);

    return(
        <div className="blog">
            <AnimationOnScroll animateIn="animate__fadeIn" className="dvl-grid">
                { posts.length === 0 && <div className="dvl-information-alert">Brak postów</div> }
                { posts.map(post => (                   
                    <div className="dvl-card" key={ post.PostId }>
                        <Link to={ `single/${ post.PostId }` }>
                            <div className="dvl-card-image">
                                <img src={ post.PostImg } alt="post" />
                            </div>
                            <div className="dvl-card-content">
                                <h3>{ post.PostTitle }</h3>
                                <p>{ post.PostDescription.split(' ').slice(0, 20).join(' ') + '...' }</p>
                            </div>
                        </Link>
                    </div>
                )) }    
            </AnimationOnScroll>
        </div>
    );
}

export default Blog;